import {
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Stack } from "@mui/material";
import React from "react";
import SendIcon from "@mui/icons-material/Send";
import { Link } from "react-router-dom";

export const Footer = () => {
  const theme = useTheme();
  const is700 = useMediaQuery(theme.breakpoints.down(700));

  const labelStyles = {
    fontWeight: 300,
    cursor: "pointer",
  };

  return (
    <Stack
      sx={{
        backgroundColor: theme.palette.primary.main,
        paddingTop: "3rem",
        paddingLeft: is700 ? "1rem" : "3rem",
        paddingRight: is700 ? "1rem" : "3rem",
        paddingBottom: "1.5rem",
        rowGap: "5rem",
        color: theme.palette.primary.light,
        justifyContent: "space-around",
      }}
    >
      {/* upper */}
      <Stack
        flexDirection={"row"}
        rowGap={"1rem"}
        justifyContent={is700 ? "" : "space-around"}
        flexWrap={"wrap"}
      >
        <Stack rowGap={"1rem"} padding={"1rem"}>
          <Typography variant="h6" fontSize={"1.5rem"}>
            Exclusive
          </Typography>
          <Typography variant="h6">Subscribe</Typography>
          <Typography sx={labelStyles}>Get 10% off your first order</Typography>
          <TextField
            placeholder="Enter your email"
            sx={{ border: "1px solid white", borderRadius: "6px" }}
            InputProps={{
              endAdornment: (
                <IconButton>
                  <SendIcon sx={{ color: theme.palette.primary.light }} />
                </IconButton>
              ),
              style: { color: "whitesmoke" },
            }}
          />
        </Stack>

        <Stack rowGap={"1rem"} padding={"1rem"}>
          <Typography variant="h6">Support</Typography>
          <Typography sx={labelStyles}>
            📍 Location: Pakistan
          </Typography>
          <Typography sx={labelStyles}>📧 Email: sardarlaeiq786@gmail.com</Typography>
          <Typography sx={labelStyles}>💬 WhatsApp: +923448252109</Typography>
          <Typography sx={labelStyles}>📱 Phone: 03448252109</Typography>
        </Stack>

       

        <Stack rowGap={"1rem"} padding={"1rem"}>
          <Typography variant="h6">Account</Typography>
          <Link to="/profile" style={{ textDecoration: 'none' }}>
            <Typography sx={{...labelStyles, color: theme.palette.primary.light, '&:hover': { textDecoration: 'underline' }}}>My Account</Typography>
          </Link>
          <Link to="/login" style={{ textDecoration: 'none' }}>
            <Typography sx={{...labelStyles, color: theme.palette.primary.light, '&:hover': { textDecoration: 'underline' }}}>Login / Register</Typography>
          </Link>
          <Link to="/cart" style={{ textDecoration: 'none' }}>
            <Typography sx={{...labelStyles, color: theme.palette.primary.light, '&:hover': { textDecoration: 'underline' }}}>Cart</Typography>
          </Link>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Typography sx={{...labelStyles, color: theme.palette.primary.light, '&:hover': { textDecoration: 'underline' }}}>Shop</Typography>
          </Link>
        </Stack>

        <Stack rowGap={"1rem"} padding={"1rem"}>
          <Typography variant="h6">Quick Links</Typography>
          <Link to="/privacy-policy" style={{ textDecoration: 'none' }}>
            <Typography sx={{...labelStyles, color: theme.palette.primary.light, '&:hover': { textDecoration: 'underline' }}}>Privacy Policy</Typography>
          </Link>
          <Link to="/terms-of-use" style={{ textDecoration: 'none' }}>
            <Typography sx={{...labelStyles, color: theme.palette.primary.light, '&:hover': { textDecoration: 'underline' }}}>Terms Of Use</Typography>
          </Link>
          <Link to="/faq" style={{ textDecoration: 'none' }}>
            <Typography sx={{...labelStyles, color: theme.palette.primary.light, '&:hover': { textDecoration: 'underline' }}}>FAQ</Typography>
          </Link>
          <Link to="/contact" style={{ textDecoration: 'none' }}>
            <Typography sx={{...labelStyles, color: theme.palette.primary.light, '&:hover': { textDecoration: 'underline' }}}>Contact</Typography>
          </Link>
        </Stack>

      </Stack>

      {/* lower */}
      <Stack alignSelf={"center"}>
        <Typography color={"GrayText"}>
          &copy; Nexocart Store {new Date().getFullYear()}

        </Typography>
      </Stack>
    </Stack>
  );
};
